<template>
  <v-card variant="outlined" class="contact-list-card">
    <div class="list-card-header">
      <div>
        <div class="list-card-eyebrow">{{ $t('text.contacts') }}</div>
        <h3 class="list-card-title mb-1">Customer contacts</h3>
        <p class="list-card-copy mb-0">{{ activeContactCount }} active contact{{ activeContactCount === 1 ? '' : 's' }}</p>
      </div>

      <div class="list-card-actions">
        <v-checkbox v-model="showInactive" label="Show inactive" class="ma-0" dense hide-details></v-checkbox>
      </div>
    </div>

    <v-divider></v-divider>

    <div class="list-card-progress">
      <v-progress-linear v-if="loading" indeterminate height="2"></v-progress-linear>
    </div>

    <v-list class="list-card-body py-0">
      <ContactListItem :header="true"></ContactListItem>
      <ContactListItem v-for="item in filteredContacts" :key="item.Id" :item="item" @toggleActive="toggleActive(item)">
      </ContactListItem>
    </v-list>

    <div v-if="!loading && filteredContacts.length === 0" class="list-card-empty">
      <v-icon color="grey" size="26" class="mb-2">mdi-account-box-outline</v-icon>
      <div>No contacts to show</div>
    </div>

    <confirm-dialog ref="ConfirmDialog"></confirm-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      Contact deactivated
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="unToggleActive()">
          {{ $t("text.undo") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>


<script>
import http from "@/api/client";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog.vue";
import ContactListItem from "@/components/ListItems/ContactListItem.vue";

export default {
  name: "ContactList",
  components: {
    ConfirmDialog,
    ContactListItem,
  },

  data() {
    return {
      hintExpanded: false,

      loading: false,
      contacts: [],
      showInactive: false,

      lastToggledId: null,
      snackbar: false,
      timeout: 5000,
    };
  },

  created() {
    this.getContacts();
  },

  methods: {
    setContactActive(id, isActive) {
      const itemIndex = this.contacts.findIndex((contact) => contact.Id === id);
      if (itemIndex >= 0) {
        this.contacts.splice(itemIndex, 1, {
          ...this.contacts[itemIndex],
          IsActive: isActive,
        });
      }
    },

    async getContacts() {
      this.loading = true;
      try {
        const response = await http().get("api2/customer/userinfo/organization");
        const organization = response.data;
        this.contacts = organization.CustomerPeople || [];
      }
      finally {
        this.loading = false;
      }
    },

    async unToggleActive() {
      await this.toggleActiveCall(this.lastToggledId);
      var target = this.contacts.find((x) => x.Id === this.lastToggledId);
      if (target) {
        this.setContactActive(this.lastToggledId, !target.IsActive);
      }
      this.snackbar = false;
    },

    async toggleActiveCall(id) {
      var result = await http().patch("api2/customer/userinfo/Contact/ToggleActive/" + id);
      return result;
    },

    async toggleActive(item) {
      var result = true;
      //show confirm dialog if deactivating
      if (!item.IsActive) {
        result = await this.$refs.ConfirmDialog.show({
          title: "Deactivate " + item.Name,
          message: "Are you sure?",
          okButton: "Deactivate",
          cancelButton: "Cancel",
        });
      }
      //undo change if cancel
      if (!result) {
        this.setContactActive(item.Id, !item.IsActive);
        return;
      }
      else {
        this.lastToggledId = item.Id;
        await this.toggleActiveCall(item.Id);
        this.snackbar = true;
      }
    },
  },

  computed: {
    filteredContacts() {
      return this.contacts.filter((x) => (this.showInactive ? true : x.IsActive));
    },

    activeContactCount() {
      return this.contacts.filter((contact) => contact.IsActive).length;
    },
  },

  watch: {},
};
</script>

<style scoped>
.contact-list-card {
  border-radius: 8px;
  overflow: hidden;
}

.list-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
}

.list-card-eyebrow {
  margin-bottom: 4px;
  color: var(--v-primary-base, #1976d2);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.list-card-title {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.1rem;
  line-height: 1.2;
}

.list-card-copy {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.88rem;
}

.list-card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.list-card-progress {
  min-height: 2px;
}

.list-card-body {
  background: #ffffff;
}

.list-card-empty {
  padding: 28px 16px 32px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.92rem;
  text-align: center;
}

@media (max-width: 600px) {
  .list-card-header,
  .list-card-actions {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>